<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="6" cy="6" r="5" fill="currentColor" />
    <circle cx="6" cy="6" r="2.25" fill="white" />
  </svg>
</template>
